import cn from "classnames"
import { Fragment } from "react"

import { getColorBySeverity, Severity } from "@/domain/vulnerability"

import styles from "./SeverityLetter.module.scss"

import type { SeverityLetterProps } from "."

export const SeverityLetter = (props: SeverityLetterProps) => {
  const { severity, size, classes = {}, Wrapper = Fragment } = props

  if (!severity) return null

  const severityLowerCase = severity.toLowerCase()
  const backgroundColor = getColorBySeverity(severityLowerCase as Severity)
  const className = cn(
    styles.container,
    size === "large" && styles.largeSize,
    classes.container
  )
  const letter = severity[0]
  const tooltipContent = `${letter.toUpperCase()}${severityLowerCase.slice(1)}`
  const wrapperProps = Wrapper === Fragment ? {} : { title: tooltipContent }

  return (
    <Wrapper {...wrapperProps}>
      <span
        className={className}
        style={{
          backgroundColor: `var(--bg-severity-letter, ${backgroundColor})`
        }}
        data-tooltip-content={tooltipContent}
      >
        {letter}
      </span>
    </Wrapper>
  )
}
